import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../models/api-resource.interface';
import { LegalForm } from './legal-form.interface';

export class LegalFormService {
   async getLegalForms(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<LegalForm>>>(`/legal-forms`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
